import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import classes from './EditTwoFactorModal.module.css';

export const TotpEnrollmentSuccessModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => (
    <Modal isOpen={isOpen} className={classes.modal} contentClassName={classes.modalContent}>

      <ModalHeader className={classes.modalHeader}>
        Email sent!
      </ModalHeader>
      <ModalBody>
        <p className="mb-0">
          An email has been sent to the user's primary email address to set up their login using the Authenticator App.
        </p>
      </ModalBody>
      <ModalFooter className={classes.modalFooter}>
        <Button
          color="primary"
          size="sm"
          onClick={onClose}
        >
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );